export default class ScriptsInstaller {

    static installScripts() {

        $(document).ready(() => {

            setTimeout(() => {

                this.#hotjarScript();
                this.#leadsterScript();
                this.#facebookTempHubScript();
                this.#googleTagManagerScript();
                this.#googleOptimize();
            
            }, 9000);
            
        });
        
    }

    static #hotjarScript(){

        window.hj = window.hj || function() {
            (window.hj.q = window.hj.q || []).push(arguments);
        };

        window._hjSettings = {
            hjid: 2675376,
            hjsv: 6
        };

        var hotjarScriptSrc = 'https://static.hotjar.com/c/hotjar-' + window._hjSettings.hjid + '.js?sv=' + window._hjSettings.hjsv;
        this.#addScriptToHead(hotjarScriptSrc);

    }

    static #leadsterScript(){

        var leadsterScriptSrc = "https://cdn.leadster.com.br/neurolead/neurolead.min.js";

        window.neuroleadId = "xeL3Xr7hYSxbODHsd6mVVlxGh";

        this.#addScriptToHead(leadsterScriptSrc);

    }

    static #addScriptToHead(src) {

        var headElement = document.head || document.getElementsByTagName("head");
        var scriptElement = document.createElement("script");
        scriptElement.defer = true;
        scriptElement.type = "text/javascript";
        scriptElement.src = src;
        headElement.appendChild(scriptElement);

    }

    static #facebookTempHubScript(){

        if (window.fbq) return;

        window.fbq = function () {
            window.fbq.callMethod ?
                window.fbq.callMethod.apply(window.fbq, arguments) :
                window.fbq.queue.push(arguments);
        };
    
        if (!window._fbq) window._fbq = window.fbq;
    
        window.fbq.queue = [];
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
    
        // Use the addScriptToHead function to add the Facebook pixel script
        this.#addScriptToHead('https://connect.facebook.net/en_US/fbevents.js');
    
        fbq('init', '592719678065005');
        fbq('track', 'PageView');
    
        var noscriptElement = document.createElement('noscript');
        var imgElement = document.createElement('img');
    
        imgElement.setAttribute('height', '1');
        imgElement.setAttribute('width', '1');
        imgElement.style.display = 'none';
        imgElement.src = 'https://www.facebook.com/tr?id=592719678065005&ev=PageView&noscript=1';
    
        noscriptElement.appendChild(imgElement);
        document.body.appendChild(noscriptElement);
    }

    static #googleTagManagerScript(){

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });

        // Use the addScriptToHead function to add the Google Tag Manager script
        this.#addScriptToHead('https://www.googletagmanager.com/gtm.js?id=GTM-PBP89JM');
    }

    static #googleOptimize(){

        // Use the addScriptToHead function to add the Google Optimize script
        this.#addScriptToHead('https://www.googleoptimize.com/optimize.js?id=OPT-WTJWKZN');

    }

}